import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { resetPendingFitMap } from '@/map'
import { useAppDispatch } from '@/store'
import { selectDeviceMapStyles, updateMapStyle } from '@/features/domain/ui'
import { selectTerritoryId } from '@/features/domain/territory'

export function useEnsureDeviceVisibility() {
  const dispatch = useAppDispatch()

  const territoryId = useSelector(selectTerritoryId)

  // ATTENTION: this REF is intentionally created and not updated
  const rOriginalMapStyle = useRef(useSelector(selectDeviceMapStyles))

  useEffect(() => {
    // access previously active device Map Styles
    const originalMapStyle = rOriginalMapStyle.current

    // make device style visible
    dispatch(
      updateMapStyle({
        type: 'device',
        mode: 'on',
      }),
    )

    return () => {
      resetPendingFitMap()

      // restore previously active device Map Styles
      dispatch(
        updateMapStyle({
          type: 'device',
          mode: originalMapStyle.mode,
        }),
      )
    }
  }, [dispatch, territoryId])
}
